export default __webpack_public_path__ + "static/media/phone.8cae7a56.svg";